module.exports = __webpack_public_path__ + "static/media/persona_4.a5b48a2d.png";